export default {
  methods: {
    getBidState(state) {
      const bidStatesMap = {
        L: 'ADVERTISEMENT.BID.LOSER',
        A: 'ADVERTISEMENT.BID.ALERTED',
        W: 'ADVERTISEMENT.BID.ACTIVE',
        R: 'ADVERTISEMENT.BID.REJECTED',
        P: 'ADVERTISEMENT.BID.PENDING',
        C: 'ADVERTISEMENT.BID.CAMPAIGN_STOPPED',
      };

      if (state in bidStatesMap) {
        return this.$t(bidStatesMap[state]);
      }

      return '';
    },
  },
};
